;(() => {
  const VISIBLE = 'is-visible'

  const initFlashAlert = (node) => {
    if (!node || node.dataset.initialized === 'true') return

    const messageContainer = node.querySelector('[data-flash-alert-message]')
    if (!messageContainer) return

    const open = (alertMessage) => {
      if (!alertMessage) return
      messageContainer.textContent = alertMessage
      node.classList.add(VISIBLE)
      messageContainer.addEventListener(
        'animationend',
        () => {
          node.classList.remove(VISIBLE)
        },
        { once: true }
      )
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-flash-trigger]')
      if (!trigger) return
      if (!window.Shopify?.designMode) return
      open(trigger.dataset.flashMessage)
    })

    document.addEventListener('flash-alert', (event) => {
      open(event.detail?.alert || event.detail)
    })

    // Legacy evx event name used elsewhere historically
    document.addEventListener('flart-alert', (event) => {
      open(event.detail?.alert || event.detail)
    })

    window.showFlashAlert = open
    node.dataset.initialized = 'true'
  }

  const init = (root = document) => {
    root.querySelectorAll('[data-flash-alert]').forEach(initFlashAlert)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init())
  } else {
    init()
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target))
})()
